'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/router/timezone/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "timezone" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/router/timezone/StaticView#model
   * @type {actions/router/timezone/EditTimezone}
   */

  template: twig({data: tpl}),
});
